import './index.css';
import { jsx } from 'react/jsx-runtime';
import { F as FormHelperRenderer } from './FormHelperRenderer-Z-tj85JY.js';
import { useFormHelperState } from './useFormHelperState.js';
import 'classnames';
import './useFormHelperAnimation.js';
import 'react';
import '@hh.ru/magritte-common-func-utils';
import '@hh.ru/magritte-common-resize';
import '@hh.ru/magritte-ui-typography';
import '@hh.ru/magritte-common-dom-storage';

const FormHelper = (props) => {
    const formHelperState = useFormHelperState(props);
    return jsx(FormHelperRenderer, { ...props, ...formHelperState });
};

export { FormHelper };
//# sourceMappingURL=FormHelper.js.map
